import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRecoilState } from 'recoil';
import { useQuery } from 'react-query';
import { currentUserInfo, currentUserInfoState } from 'atoms';
import Header from 'components/Common/Header';
import MenuItem from 'components/Main/MenuItem';
import { getCurrentAptData, getMyData } from 'fetchers';
import { useLocation } from 'react-router-dom';

const Main = () => {
  const [userId, setUserId] = useState();
  const [userData, setUserData] = useRecoilState(currentUserInfo);

  const location = useLocation();
  alert(location);

  useEffect(() => {
    // (async () => {
    //   const onMessageHandler = async (e) => {
    //     const data = JSON.parse(e.data);
    //     setUserId(data.userId);
    //   };
    //   const isUIWebView = () => {
    //     return navigator.userAgent
    //       .toLowerCase()
    //       .match(/\(ip.*applewebkit(?!.*(version|crios))/);
    //   };
    //   const receiver = isUIWebView() ? window : document;
    //   receiver.addEventListener('message', onMessageHandler);
    //   return () => {
    //     return receiver.removeEventListener('message', onMessageHandler);
    //   };
    // })();
  }, []);

  const { isLoading: queryUserDataLoading } = useQuery(
    ['userData'],
    async () => await getCurrentAptData(window.location.host, userId),
    {
      enabled: !!userId,
      onSuccess: (data) => {
        return setUserData(data);
      },
    },
  );

  const { isLoading: mypageDataLoading } = useQuery(
    ['mypage', userData?.user?.no],
    async () => await getMyData(userData?.user?.no),
    {
      enabled: !!userData?.user?.no,
      staleTime: 60 * 60 * 10,
    },
  );

  return (
    !queryUserDataLoading &&
    !mypageDataLoading && (
      <Container>
        <MainContainer className='d-flex flex-column'>
          <Header title='마이페이지' isIcon={true} />
          {/* <CardContainer className='container-fluid d-flex flex-row my-4'>
            <MainCard userData={data} />
            <SubCard />
          </CardContainer> */}
          {/* <Border className='mt-2' /> */}
          <MenuItem />
        </MainContainer>
      </Container>
    )
  );
};

const Container = styled.section``;
const MainContainer = styled.article``;
const CardContainer = styled.section`
  height: 148px;
`;
const Border = styled.div`
  height: 7px;
  background-color: ${(props) => props.theme.$gray100};
`;

export default Main;
